import {useEffect} from "react";
import sdk from "scoutli-sdk";
import {useNavigate} from "react-router-dom";

const Page = ({content}) => {
    const navigate = useNavigate()

    useEffect(() => {
        async function check(){
            let accessToken = localStorage.getItem("accessToken");

            let loggedIn = false

            if (accessToken) {
                const user = await sdk.user(accessToken).get.userData().catch(() => {
                    localStorage.removeItem("accessToken")
                })

                if (user) {
                    loggedIn = true
                }
            }

            if (loggedIn){
                return navigate("/")
            }
        }

        check()
    })

    return (
        <>
            {content}
        </>
    )
}

export default Page;